<template>
  <SharedCategoryPage
    page-type="collabs"
    :category="category"
  />
</template>

<script lang="ts" setup>
// ─── Page Meta ───────────────────────────────────────────────────

definePageMeta({
  layout: 'product-list',
  ssr: true
})
const route = useRoute()
const category = computed(() => route.params.category as string | undefined)
</script>
